import { formatTimeOrNull, formatTimeValueOrNull } from './date-time-formatters';
import { isShiftUserDefinedTimes } from './time-utils';

/**
 * Formats shift details, with optional time value. If the shift is user-defined, it will show as user-defined times.
 * @param shiftCode
 * @param startTime
 * @param endTime
 * @param timeValue
 * @returns
 */
export const formatShiftDetails = (shiftCode: string, startTime: Date, endTime: Date, timeValue?: number) => {
	if (isShiftUserDefinedTimes(startTime, endTime)) {
		return `${shiftCode} - user-defined times`;
	}

	if (timeValue !== undefined) {
		return `${shiftCode} (${formatTimeOrNull(startTime)} - ${formatTimeOrNull(endTime)} TV: ${formatTimeValueOrNull(
			timeValue,
		)})`;
	}

	return `${shiftCode} (${formatTimeOrNull(startTime)} - ${formatTimeOrNull(endTime)})`;
};

export const formatShiftTimes = (startTime: Date, endTime: Date, timeValue?: number) => {
	if (isShiftUserDefinedTimes(startTime, endTime)) {
		return 'user-defined times';
	}

	if (timeValue !== undefined) {
		return `(${formatTimeOrNull(startTime)} - ${formatTimeOrNull(endTime)} TV: ${formatTimeValueOrNull(
			timeValue,
		)})`;
	}

	return `(${formatTimeOrNull(startTime)} - ${formatTimeOrNull(endTime)})`;
};

export const renderShiftDetails = (shiftCode: string, startTime: Date, endTime: Date, timeValue: number) => {
	return `<span class="shift-code">${shiftCode}</span> <span class="times">${formatTimeOrNull(
		startTime,
	)} - ${formatTimeOrNull(
		endTime,
	)}</span><span class="prompt">TV</span><span class="time-value">${formatTimeValueOrNull(timeValue)}</span>`;
};
